module.exports = __webpack_public_path__ + "img/landing18.1edb08eb.jpg";